import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_stacktrace/product-roadmap/$roadmapId/_layout/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/product-roadmap/$roadmapId/detail',
      params: { roadmapId: params.roadmapId },
    });
  },
});
